export var HUB_ROUTE_NAME = 'hub';
export var HUB_ROUTE_PATH = '/';
export var HUB_CUSTOM_PAGE_ROUTE_NAME = 'hub-custom-page';
export var HUB_CUSTOM_PAGE_ROUTE_PATH = '/page/:id/:title?';